$(function () {
  $('.colorpicker__color').on('click', function () {
    var picker = $(this).parent();
    picker.toggleClass('colorpicker__preview--active');
    $('body').off('click.colorpicker');

    setTimeout(function () {
      $('body').on('click.colorpicker', function (ev) {
        if (!$(ev.target).hasClass('colorpicker__overlay') && !$(ev.target).parents('.colorpicker__overlay').length) {
          picker.removeClass('colorpicker__preview--active');
          $('body').off('click.colorpicker');
        }
      });
    }, 32);
  });

  $('.input__wrapper[data-input-type="colorpicker"] [data-form-value]').on('input', function () {
    $(this).parents('.input__wrapper').find('.colorpicker__color').css({backgroundColor: $(this).val()});
  });
})
